import { useSelector } from "react-redux";
import { selectIsDynamicsCompanyAsLeadExportClaimEnabled } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamicsSelectors";
import { selectIsCompanyAsLeadExportClaimEnabled } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

const claimSelectors: Partial<Record<Integration, (state: any) => boolean>> = {
    salesforce: selectIsCompanyAsLeadExportClaimEnabled,
    dynamics: selectIsDynamicsCompanyAsLeadExportClaimEnabled,
};

export const useIsCompanyAsLeadClaimEnabled = (integrationName: Integration): boolean => {
    const selector = claimSelectors[integrationName];
    return useSelector(selector ?? (() => false));
};
